export const removeAllHTMLTags = (str: string): string => {
  if (!str) {
    return str;
  }

  return str.replace(/(<([^>]+)>)/gi, '');
};
